// Override Settings
var bcSfSearchSettings = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  if (jQ('.fancybox-overlay').length > 0) {
    jQ(suggestionElement).parent().css({
      'position': 'fixed',
    });
    jQ(suggestionElement).css({
      'overflow-y': 'scroll',
      'height': '300px'
    });
  }
};